import './style.css';
import 'svgmap/dist/svgMap.min.css';
import 'flowbite';
import './dark-mode';
import 'lazysizes';